import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "hub-layout"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "learning-center-container"
};
const _hoisted_4 = {
  class: "learning-center-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_TopNav = _resolveComponent("TopNav");
  const _component_Sidebar = _resolveComponent("Sidebar");
  const _component_Login = _resolveComponent("Login");
  const _component_VideoDetail = _resolveComponent("VideoDetail");
  const _component_GoTop = _resolveComponent("GoTop");
  const _component_SvgIcon = _resolveComponent("SvgIcon");
  const _directive_fixed_top_nav = _resolveDirective("fixed-top-nav");
  return $setup.isEmbedLayout ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("header", null, [_createVNode(_component_TopNav)])), [[_directive_fixed_top_nav]]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    id: "top-nav-height"
  }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("aside", null, [_createVNode(_component_Sidebar, {
    id: "sidebar"
  })]), _createElementVNode("main", null, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    id: "text-banner"
  }, null, -1)), $setup.isNotAuth ? (_openBlock(), _createBlock(_component_Login, {
    key: 0
  })) : $setup.isShowDetail ? (_openBlock(), _createBlock(_component_VideoDetail, {
    key: 1
  })) : (_openBlock(), _createBlock(_component_router_view, {
    key: 2
  }))])]), _createVNode(_component_GoTop), _createVNode(_component_SvgIcon)])]));
}